  import React, { useEffect, useState } from "react";
  import { useParams, useNavigate } from "react-router-dom";
  import { fetchAuthenticatedUrl, postURL } from "../utils";
  import Checklist from "../components/Checklist";
  import "../assets/styles/Simulation.css";
  import ChatDetails from "../components/ChatDetails";
  import { mapJsonToSimResponse } from "../models/Simulation";
  import { Dialog } from "@mui/material";
  import YouTube from "react-youtube";
  import HelpIconModal from "../components/HelpIconModal";
  import SummaryBox from "../components/SummaryBox";
  import LogoutButton from "../components/LogoutButton";
  import ResponseTimer from "../components/ResponseTimer";
import {  bardInfoAssessment } from "../components/ChatStatus";
import Support from "../components/support";
import MicrophonePermissionPopup from "../components/MicrophonePermissionPopup";
  const SimulationChat = () => {
    const { sim_id, chat_id } = useParams();
    const [simulation, setSimulation] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [isChatInitialized, setChatInitialized] = useState(false);
    const [isAssessment, setIsAssessment] = useState(false);
    const [videoDialogOpen, setVideoDialogOpen] = useState(false);
    const [recheckGoalStatus, setRecheckGoalStatus] = useState(false);
    const [refreshUrl, setRefreshUrl] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const [feedbackActive, setFeedbackActive] = useState(false);
    const [summary, setSummary] = useState("");
    const [showSummaryBox, setShowSummaryBox] = useState(false);
    const [summaryBoxVisible, setSummaryBoxVisible] = useState(true);
    const [personaImage, setPersonaImage] = useState(null);

    // Timer state
    const [timerRunning, setTimerRunning] = useState(false);
    const [timerStartTime, setTimerStartTime] = useState(null);
    const [currentResponseTime, setCurrentResponseTime] = useState(0);

    // Microphone permission state
    const [showMicrophonePermissionPopup, setShowMicrophonePermissionPopup] = useState(false);

    const refreshCheckList = () => {
      setRecheckGoalStatus((prev) => !prev);
    }

    // Timer control functions
    const startTimer = () => {
      setTimerStartTime(Date.now());
      setTimerRunning(true);
      setCurrentResponseTime(0);
    };

    const stopTimer = () => {
      setTimerRunning(false);
      return currentResponseTime;
    };

    const resetTimer = () => {
      setTimerRunning(false);
      setTimerStartTime(null);
      setCurrentResponseTime(0);
    };

    const handleTimeUpdate = (elapsedTime) => {
      setCurrentResponseTime(elapsedTime);
    };

    useEffect(() => {
      console.log("in useffect with sim_id and chat_id");
      let url = "";
      if (sim_id && chat_id) {
        url = `${process.env.REACT_APP_SIM_BACKEND_HOST}/sim/${sim_id}/${chat_id}`;
        setRefreshUrl(url);
      } else if (sim_id && !chat_id) {
        url = `${process.env.REACT_APP_SIM_BACKEND_HOST}/sim/${sim_id}`;
      }

      fetchAuthenticatedUrl(url).then((resp) => {
        console.log(resp);
        if (resp.data) {
          setSimulation(mapJsonToSimResponse(resp.data));
          localStorage.setItem("sim_type", resp.data?.sim_type);
          //TODO handle this
          if (resp.data.is_assessment) {
            setIsAssessment(true);
          }
          if (resp.data.summary_required) {
            setShowSummaryBox(true);
          }
          if (resp.data.chat_response[0].status === "CLOSED") {
            navigate(`/sim/${sim_id}/${chat_id}/transcript`);
          } else if (resp.data.status == "ACTIVE") {
            setChatInitialized(true);
          }
        } else if (resp.status === 401) {
          console.log("from unauthorized", resp.status);
          navigate(`/error/${resp.status}`);  
        } else {
          console.log(resp.error);
          navigate(`/error/${resp.error.message}`);
        }
        setIsLoading(false);
      });
    }, [sim_id, chat_id]);

    useEffect(() => {
      localStorage.setItem("session_start_time", Date.now());
      
    }, []);


    useEffect(() => {
      const fetchImgUrl = `${process.env.REACT_APP_SIM_BACKEND_HOST}/sim/${simulation?.personaId}/image`;
      postURL(fetchImgUrl).then((resp) => {
        console.log(resp);
        setPersonaImage(resp.data);
      });
      console.log("persona image is ", personaImage);
    }, [simulation]);

    // Check if timer should start based on existing messages
    useEffect(() => {
      if (simulation && simulation.chatResponse && simulation.chatResponse[0] && simulation.chatResponse[0].messages) {
        const messages = simulation.chatResponse[0].messages;
        
        // If there are messages and the last message is from the AI (B), start the timer
        if (messages.length > 0 && messages[messages.length - 1].sender === "B") {
          console.log("Starting timer because last message is from AI");
          startTimer();
        }
      }
    }, [simulation]);

    // Check microphone permission status
    useEffect(() => {
      const checkMicrophonePermission = async () => {
        try {
          // Check if Permissions API is available
          if (navigator.permissions && navigator.permissions.query) {
            const result = await navigator.permissions.query({ name: 'microphone' });
            
            if (result.state === 'denied') {
              setShowMicrophonePermissionPopup(true);
            }
            
            // Listen for permission changes
            result.onchange = () => {
              if (result.state === 'denied') {
                setShowMicrophonePermissionPopup(true);
              } else if (result.state === 'granted') {
                setShowMicrophonePermissionPopup(false);
              }
            };
          } else {
            // Fallback: Try to access microphone and catch errors
            try {
              const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
              stream.getTracks().forEach(track => track.stop());
            } catch (error) {
              if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                setShowMicrophonePermissionPopup(true);
              }
            }
          }
        } catch (error) {
          console.error("Error checking microphone permission:", error);
          // Fallback: Try to access microphone and catch errors
          try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach(track => track.stop());
          } catch (err) {
            if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
              setShowMicrophonePermissionPopup(true);
            }
          }
        }
      };

      // Only check permission after simulation is loaded
      if (!isLoading && simulation) {
        checkMicrophonePermission();
      }
    }, [isLoading, simulation]);

    if (isLoading) {
      return <div>Loading...
        <Support />
      </div>;
    }
    if (error) {
      return <div>Error: {error}
        <Support />
      </div>;
    }

    if (!simulation) {
      return <div>No simulation found
        <Support />
      </div>;
    }

    const handleFeedbackClick = () => {
      setShowFeedback((prev) => !prev);
      if (feedbackActive) {
        setFeedbackActive(false);
      }
    }

    const handleSummarySubmit = () => {
      console.log("summary submitted", summary);
    }

    const handleSummaryClose = () => {
      setSummary("");
      setSummaryBoxVisible(false);
    }

    const toggleSummaryBox = () => {
      setSummaryBoxVisible(prev => !prev);
    };

    const toggleBardPopover = () => {
      // navigate(`/sim/${sim_id}/${chat_id}/transcript`);
    }

    return (
      <div className={`flex flex-col `}>
        {/* <div className="absolute top-5 right-10 z-12"> <LogoutButton /></div> */}
        
        {/* Response Timer */}
        {simulation.config.isTimeRecordingEnabled &&<ResponseTimer 
          isRunning={timerRunning}
          startTime={timerStartTime}
          onTimeUpdate={handleTimeUpdate}
        />}
        
        <div className="flex justify-between">
          <div className="flex flex-row gap-4 items-baseline">
            <button
              className="border rounded-lg bg-blue-500 p-2 text-white w-[200px] mb-2"
              onClick={() => setVideoDialogOpen(true)}
            >
              Watch Instruction Video
            </button>
            <div className="flex gap-2">
            <HelpIconModal />
            
          </div>
          </div>
          
        </div>
        
        <div className="flex flex-col lg:flex-row gap-4 relative">
      
        {<div className="w-full lg:w-1/4 bg-white p-4 rounded-l-lg shadow-md flex flex-col justify-between">
            <div className="mb-4">
              <div className="p-1 rounded-lg">
                <h2 className="text-lg font-bold text-green-700">{!isAssessment ? "Objectives" : "About the Role Play"}</h2>
              {!isAssessment ? <Checklist
                  refreshUrl={refreshUrl}
                  stageHistory={simulation.chatResponse[0]?.stageHistory}
                  currStage={simulation.chatResponse[0].stage}
                  goals={simulation.goals}
                  recheckGoalStatus={recheckGoalStatus}
                />:bardInfoAssessment(simulation.simType, personaImage, simulation)}
              </div>
              { simulation.config.realtimeFeedbackConfig.length>0 &&
            <div className="flex flex-row mt-4">
              <div className="flex flex-col">
                <h2 className={`text-lg font-bold cursor-pointer ${feedbackActive&&!showFeedback ? "text-yellow-700" : ""}`} onClick={handleFeedbackClick}>{showFeedback ? "Hide feedback" : "Feedback"}</h2>
                
              </div>
            </div>}
            </div>
              <p className="text-sm text-gray-600 mt-1">
              Note: If the role play gets stuck, just refresh the page to continue from where you left off.
            </p>
          </div>}
          <div className= "w-full lg:w-2/4 rounded-l-lg bg-white p-4  shadow-md flex-1 flex flex-col">
            <div className="bg-white p-4 rounded-lg flex-1">
              <div className="h-full overflow-y-auto">
                <ChatDetails
                  showFeedback={showFeedback}
                  setFeedbackActive={setFeedbackActive}
                  refreshCheckList={refreshCheckList}
                  simulation={simulation}
                  chat={simulation.chatResponse[0]}
                  personaId={simulation.personaId}
                  summary={summary}
                  startTimer={startTimer}
                  stopTimer={stopTimer}
                  resetTimer={resetTimer}
                  currentResponseTime={currentResponseTime}
                />
              </div>
            </div>
          </div>
          {showSummaryBox  && (
            <div className={`${summaryBoxVisible ? 'w-full lg:w-1/4' : "w-0"}`}>
              <SummaryBox 
                summary={summary} 
                onChange={setSummary} 
                onSubmit={handleSummarySubmit} 
                onClose={handleSummaryClose}
                visible={summaryBoxVisible}
                onToggle={toggleSummaryBox}
              />
            </div>
          )}
        </div>
      {isAssessment && <div className="text-sm text-gray-600 mt-1 text-center">
        Note: If the role play gets stuck, just refresh the page to continue from where you left off.
        </div>}
        <Dialog
          open={videoDialogOpen}
          onClose={() => setVideoDialogOpen(false)}
          maxWidth="xl"
        >
          <YouTube
            videoId="-j9h2xFu6g0"
            opts={{
              height: "380",
              width: "730",
              playerVars: {
                autoplay: 1,
              },
            }}
          />
        </Dialog>
        <MicrophonePermissionPopup
          open={showMicrophonePermissionPopup}
          onClose={() => setShowMicrophonePermissionPopup(false)}
          onRequestPermission={async () => {
            // Re-check permission after user tries to grant it
            try {
              const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
              stream.getTracks().forEach(track => track.stop());
              setShowMicrophonePermissionPopup(false);
            } catch (error) {
              console.error("Microphone permission still denied:", error);
            }
          }}
        />
      </div>
    );
  };

  export default SimulationChat;
